
import { COMPONENT_NAME as PACKAGE_CONFIRM_COMPONENT_NAME, PackageConfirmComponent } from './package-confirm/package-confirm.component'
import { PackageDetailsDirective } from '../details/packages-details.directive'
import { PackageCreateEditDirective } from '../create-edit/packages-create-edit.directive'

export const COMPONENTS_MODULE_NAME = 'simax.packages.components'
export const CREATE_EDIT_DIRECTIVE_NAME: string = 'packageCreateEdit'
export const DETAILS_DIRECTIVE_NAME: string = 'packageDetails'

const module = angular.module(COMPONENTS_MODULE_NAME, [])

module.component(PACKAGE_CONFIRM_COMPONENT_NAME, new PackageConfirmComponent())

module.directive(DETAILS_DIRECTIVE_NAME, [() => new PackageDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new PackageCreateEditDirective()])

